import ResultsLayout from 'components/layout/ResultsLayout';

import Result from '../modules/results';

const ResultPage = () => (
  <ResultsLayout>
    <Result />
  </ResultsLayout>
);

export default ResultPage;
